/* CLAYCALI 2/11/26: extras for page.p4-gift(-b): gold price in the headline pill, reviews moved under the closing button,
   reviews mixed (Lumina every 3rd card, max 6, other products spread out). */
(function(){
  var r=document.getElementById('ccp4'); if(!r) return;
  var s=r.querySelector('.p4-h1>span'); if(s) s.innerHTML=s.textContent.replace(/(\$\d+)/,'<b>$1</b>');
  var p=r.querySelector('.p4-proof'), f=r.querySelector('.p4-final');
  if(p&&f){ f.parentNode.insertBefore(p,f.nextSibling); p.classList.add('p4-proof--end'); }
  var t=r.querySelector('.p4-proof [data-proof-track]'); if(!t) return;
  var lum=[], g={}, keys=[];
  Array.prototype.slice.call(t.children).forEach(function(c){
    var e=c.querySelector('.p4-rev__p span'), k=e?e.textContent:'x';
    if(/^Lumina/i.test(k)){ lum.push(c); return; }
    if(!g[k]){g[k]=[];keys.push(k);} g[k].push(c);
  });
  var others=[], last=null, n=0; keys.forEach(function(k){ n+=g[k].length; });
  while(others.length<n){
    var best=null;
    keys.forEach(function(k){ if(!g[k].length||k===last) return; if(!best||g[k].length>g[best].length) best=k; });
    if(!best) best=last;
    others.push(g[best].shift()); last=best;
  }
  var keepL=lum.slice(0,6), out=[], i=0;
  while(keepL.length||others.length){
    if(i%3===0&&keepL.length) out.push(keepL.shift()); else if(others.length) out.push(others.shift()); else out.push(keepL.shift());
    i++;
  }
  lum.slice(6).forEach(function(c){ c.remove(); });
  out.forEach(function(c){ t.appendChild(c); });
})();
